import React, { useContext } from "react";
import { BrowserRouter, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import LoggedInLayout from "../layout";
import Dashboard from "../pages/Dashboard/";
import Tickets from "../pages/Tickets/";
import Signup from "../pages/Signup/";
import Login from "../pages/Login/";
import Connections from "../pages/Connections/";
import Settings from "../pages/Settings/";
import Users from "../pages/Users";
import Contacts from "../pages/Contacts/";
import QuickAnswers from "../pages/QuickAnswers/";
import Queues from "../pages/Queues/";
import Company from "../pages/Company/";
import MySchedules from "../pages/MySchedules/";
import Calendar from "../pages/Calendar/";
import MyReminders from "../pages/MyReminders/";
import ProfessionalTitles from "../pages/ProfessionalTitles/";
import ScheduledMessages from "../pages/ScheduledMessages/";
import Prescriptions from "../pages/Prescriptions/";
import PrescriptionEditorPage from "../pages/Prescriptions/NewPrescription.js";
import PrescriptionTemplates from "../pages/PrescriptionTemplates/index";
import PrescriptionTemplateEditor from "../pages/PrescriptionTemplates/Editor";
import Billing from "../pages/Billing";
import MedicalHistoryIndex from "../pages/MedicalHistory";
import PatientHistory from "../pages/MedicalHistory/PatientHistory";
import PublicAccess from "../pages/PublicAccess";
import { AuthContext, AuthProvider } from "../context/Auth/AuthContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import { ThemeProvider } from "../context/DarkMode";
import { IgnoreModalProvider } from "../context/IgnoreModal/IgnoreModalContext";
import { TicketsProvider } from "../context/Tickets/TicketsContext";
import Route from "./Route";
import BackdropLoading from "../components/BackdropLoading";

const AppProviders = ({ children }) => {
  const { loading } = useContext(AuthContext);

  if (loading) {
    return <BackdropLoading />;
  }

  return (
    <WhatsAppsProvider>
      <TicketsProvider>
        {children}
      </TicketsProvider>
    </WhatsAppsProvider>
  );
};

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider>
          <IgnoreModalProvider>
            <Switch>
              <Route exact path="/login" component={Login} />
              <Route exact path="/signup" component={Signup} />
              <Route exact path="/link" component={PublicAccess} isPublic />
              <AppProviders>
                <LoggedInLayout>
                  <Route exact path="/" component={Dashboard} isPrivate />
                  <Route exact path="/tickets/:ticketId?" component={Tickets} isPrivate />
                  <Route exact path="/connections" component={Connections} isPrivate />
                  <Route exact path="/contacts" component={Contacts} isPrivate />
                  <Route exact path="/users" component={Users} isPrivate />
                  <Route exact path="/quickAnswers" component={QuickAnswers} isPrivate />
                  <Route exact path="/Settings" component={Settings} isPrivate />
                  <Route exact path="/Queues" component={Queues} isPrivate />
                  <Route exact path="/Company" component={Company} isPrivate />
                  <Route exact path="/Calendar" component={Calendar} isPrivate />
                  <Route exact path="/MySchedules" component={MySchedules} isPrivate />
                  <Route exact path="/MyReminders" component={MyReminders} isPrivate />
                  <Route exact path="/ProfessionalTitles" component={ProfessionalTitles} isPrivate />
                  <Route exact path="/ScheduledMessages" component={ScheduledMessages} isPrivate />
                  <Route exact path="/Prescriptions" component={Prescriptions} isPrivate />
                  <Route exact path="/PrescriptionTemplates" component={PrescriptionTemplates} isPrivate />
                  <Route exact path="/PrescriptionTemplates/:templateId" component={PrescriptionTemplateEditor} isPrivate />
                  <Route exact path="/Prescriptions/Editor/:contactId/:templateId" component={PrescriptionEditorPage} isPrivate />
                  <Route exact path="/billing" component={Billing} isPrivate />
                  <Route exact path="/medical-history" component={MedicalHistoryIndex} isPrivate />
                  <Route exact path="/medical-history/:contactId" component={PatientHistory} isPrivate />
                </LoggedInLayout>
              </AppProviders>
            </Switch>
            <ToastContainer autoClose={3000} />
          </IgnoreModalProvider>
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;